import React from 'react';

const Blog = () => {
    const posts = [
        { title: "Project A", content: "Details about Project A..." },
        { title: "Project B", content: "Details about Project B..." },
        { title: "Project C", content: "Details about Project C..." },
    ];

    return (
        <div className="blog-page">
            <h1>Our Blog</h1>
            {posts.map((post, index) => (
                <div key={index} className="blog-post">
                    <h2>{post.title}</h2>
                    <p>{post.content}</p>
                </div>
            ))}
        </div>
    );
};

export default Blog;